import { render, staticRenderFns } from "./ClienteProcesado.vue?vue&type=template&id=29b0b9f8&"
import script from "@/Servicios/ClienteProcesado.js?vue&type=script&lang=js&"
export * from "@/Servicios/ClienteProcesado.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports